"use client";
import { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import Blog from "@/public/images/blog.png";
const BlogCard = ({ item }) => {
  const [formattedDate, setFormattedDate] = useState("");

  useEffect(() => {
    const date = new Date(item.date).toLocaleDateString("az-AZ", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    setFormattedDate(date);
  }, [item.date]);
  return (
    <Link href={`/news/${item?.alias}?id=${item.id}`} className="blogCard">
      <div className="date">{formattedDate}</div>
      <div className="img">
        <Image
          src={item?.title_image?.main}
          alt={item?.title}
          width={1000}
          height={1000}
        />
      </div>
      <div className="blogCardBody">
        <span>{item?.title}</span>
        <p>{item?.description}</p>
      </div>
    </Link>
  );
};

export default BlogCard;
